<template>
	<base-editor-block :identifier="identifier" type="banner" contentAttr="image">
		<template v-slot:default="{ content }">
			<v-img v-if="content" :src="content" alt="..." v-bind="$attrs" />
			<v-skeleton-loader v-else type="image" />
		</template>
	</base-editor-block>
</template>

<script>
import BaseEditorBlock from '../BaseEditorBlock/App';
export default {
	name: 'Banner',
	props: {
		identifier: {
			type: String,
			require: true
		}
	},
	components: { BaseEditorBlock }
}
</script>
